import Spinner from '@gef-ui/components/atoms/Spinner/Spinner';
import chainHandlers from "@gef-ui/utils/chainHandlers";
import defaultTo from "ramda/es/defaultTo";
import React from 'react';
import { inputColor, validationColor } from '../../../../constants';
export default (({ handleAsyncValidate, asyncValidationInProgress, handleChange, displayValue, errMeta, formName, handleUpdate, handleValidate, valid, disabled, errMessage, onChange, handleFocusTrue, handleFocusFalse, value, viewParser, label, fieldName, onBlur, min, focus, onKeyUp, handleKeyUp, onFocus, ...other })=>{
    const defaultMin = min ? min : 0;
    const defaultValue = defaultTo(defaultMin, value);
    return /*#__PURE__*/ React.createElement(Spinner, {
        id: fieldName,
        validationText: errMessage,
        labelText: label,
        controlClassName: inputColor(valid),
        disabled: disabled,
        validationClassName: validationColor(valid),
        value: defaultValue,
        onChange: chainHandlers([
            handleUpdate,
            onChange
        ]),
        onFocus: chainHandlers([
            handleFocusTrue,
            onFocus
        ]),
        min: min,
        displayValue: viewParser && !focus ? viewParser(defaultValue) : defaultValue,
        onBlur: chainHandlers([
            handleFocusFalse,
            handleValidate,
            onBlur
        ]),
        onKeyUp: chainHandlers([
            onKeyUp,
            handleKeyUp
        ]),
        ...other
    });
});
